import React from "react";
import { Dropdown } from "primereact/dropdown";
import AssignmentControl from "../Tickets/AssignmentControl";

const statusOptions = ["Open", "In Progress", "Resolved", "Closed"];
const priorityOptions = ["Low", "Medium", "High", "Urgent"];

export const TicketMetaControls = ({
  ticket,
  draft,
  dirty,
  saving,
  assigning,
  assignError,
  saveMessage,
  agentOptions,
  onChange,
  onAssign,
  onUnassign,
  onSave,
}) => {
  return (
    <section className="workspace-meta">
      <div className="workspace-meta-ticket">
        <strong>SKBT-{String(ticket?.id || "").padStart(3, "0")}</strong>
        <span>{ticket?.subject || "No subject"}</span>
      </div>

      <div className="workspace-meta-controls">
        <div className="workspace-meta-field">
          <label>Status</label>
          <Dropdown
            value={draft.status}
            options={statusOptions}
            placeholder="Status"
            onChange={(event) => onChange("status", event.value || "")}
          />
        </div>

        <div className="workspace-meta-field">
          <label>Priority</label>
          <Dropdown
            value={draft.priority}
            options={priorityOptions}
            placeholder="Priority"
            onChange={(event) => onChange("priority", event.value || "")}
          />
        </div>

        <button
          type="button"
          className="workspace-save-btn workspace-save-inline"
          disabled={!dirty || saving}
          onClick={onSave}
        >
          {saving ? "Saving..." : "Save Changes"}
        </button>
      </div>

      {/* <div className="workspace-assignment-control">
        <label>Assign to:</label>
        <AssignmentControl
          value={draft.assignedTo}
          agentOptions={agentOptions}
          loading={assigning}
          error={assignError}
          onChange={(value) => onChange("assignedTo", value || "")}
          onAssign={onAssign}
          onUnassign={onUnassign}
          className="assignment-control--compact"
        />
      </div> */}

      {saveMessage?.text ? (
        <div className={`workspace-inline-${saveMessage.type || "info"}`}>{saveMessage.text}</div>
      ) : null}
    </section>
  );
};

export default TicketMetaControls;
